module.exports = __webpack_public_path__ + "img/visa.ff4cb0ae.svg";